import { useRawTokenPermissions } from "@/features/token-permissions";
import { useCurrentRawExperienceQuery } from "./useCurrentRawExperienceQuery";
import { StatusCode } from "@/types/generated/ExperienceRawServiceApi";

export function useRawExperienceReadonly() {
  const { canEditRaw } = useRawTokenPermissions();
  const rawQuery = useCurrentRawExperienceQuery();

  const statusCode = computed(() => rawQuery.data.value?.status_code);

  const isReadonly = computed(() => !canEditRaw() || statusCode.value === StatusCode.BEING_CURATED);

  return { isReadonly };
}
